import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Send } from "lucide-react";
import type { MessageInputProps } from "@/types/messages";

export const MessageInput = ({ value, onChange, onSend, disabled }: MessageInputProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Reply</CardTitle>
      </CardHeader>
      <CardContent>
        <Textarea
          placeholder="Type your message..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="mb-4"
          rows={4}
        />
        <Button
          onClick={onSend}
          disabled={!value.trim() || disabled}
          className="w-full"
        >
          <Send className="h-4 w-4 mr-2" />
          Send Reply
        </Button>
      </CardContent>
    </Card>
  );
};